import clsx from "clsx";
import { ReactNode } from "react";

import { Displayer } from "@smart/itops-sb-design-system-dom/src/components/editor";
import { Icon } from "@smart/itops-sb-design-system-dom/src/components/icon";

export type FieldGroupProps = {
  id: string;
  label: string | ReactNode;
  children: ReactNode;
  hint?: string;
  message?: string;
  messageId?: string;
  className?: string;
};

export const FieldGroup = ({
  id,
  label,
  children,
  hint,
  message,
  messageId,
  className,
}: FieldGroupProps) => (
  <div className={clsx("flex flex-col gap-small w-full", className)}>
    <label htmlFor={id}>{label}</label>
    {children}
    {hint && !message && (
      <label
        className="flex flex-wrap items-center gap-small text-grey-50 text-caption"
        htmlFor={id}
      >
        <Icon name="regularCircleInfo" className="w-[1rem] h-[1rem]" />
        <Displayer value={hint} paragraphTag="span" />
      </label>
    )}
    {message && (
      <label htmlFor={id}>
        <div
          className="flex items-center gap-1 mt-2 text-red-550"
          id={messageId}
        >
          <Icon className="w-4 h-4 mr-2" name="regularCircleExclamation" />
          <div className="text-caption font-normal">{message}</div>
        </div>
      </label>
    )}
  </div>
);
